import { adapter, initialState, State } from './invoice.state'
import * as R from 'ramda'
import { Action, createReducer, on } from '@ngrx/store'
import {
  AddInvoiceComplete,
  ArchiveInvoice,
  ArchiveInvoiceComplete,
  DeleteInvoiceComplete,
  DeleteLocalInvoicesByIds,
  DisableInvoiceOnlinePayment,
  DisableInvoiceOnlinePaymentComplete,
  EnableInvoiceOnlinePayment,
  EnableInvoiceOnlinePaymentComplete,
  FetchInvoicesComplete,
  LoadInvoiceComplete,
  LoadInvoicesComplete,
  LoadInvoicesTotalComplete,
  LoadPastDueInvoicesComplete,
  PayInvoiceWithSavedCard,
  PayInvoiceWithSavedCardComplete,
  RefundInvoice,
  RefundInvoiceComplete,
  ScheduleInvoice,
  ScheduleInvoiceComplete,
  SearchElasticInvoicesComplete,
  SendInvoice,
  SendInvoiceComplete,
  SetInvoicePaymentGateway,
  SetInvoicePaymentGatewayComplete,
  UnArchiveInvoice,
  UnArchiveInvoiceComplete,
  UpdateInvoice,
  UpdateInvoiceAddress,
  UpdateInvoiceAddressComplete,
  UpdateInvoiceComplete,
  UpdateInvoiceStatus,
  UpdateInvoiceStatusComplete,
} from './invoice.actions'
import { updateOne, upsertMany } from '@tokeet-frontend/utility'
import { ApplyInvoiceTemplateComplete } from '../../store/templates/template.actions'

export const reducer = createReducer(
  initialState,
  on(LoadInvoicesComplete, (state, { invoices }) => upsertMany(adapter, invoices, R.merge(state, { isLoaded: true }))),
  on(LoadInvoicesTotalComplete, (state, { changes }) => adapter.updateMany(changes, state)),
  on(LoadPastDueInvoicesComplete, SearchElasticInvoicesComplete, FetchInvoicesComplete, (state, { invoices }) =>
    upsertMany(adapter, invoices, state)
  ),
  on(AddInvoiceComplete, LoadInvoiceComplete, (state, { invoice }) => adapter.addOne(invoice, state)),
  on(
    PayInvoiceWithSavedCardComplete,
    SetInvoicePaymentGatewayComplete,
    EnableInvoiceOnlinePaymentComplete,
    DisableInvoiceOnlinePaymentComplete,
    UpdateInvoiceComplete,
    UpdateInvoiceStatusComplete,
    UpdateInvoiceAddressComplete,
    ScheduleInvoiceComplete,
    (state, { update }) => updateOne(adapter, update, { ...state, isUpdating: false })
  ),
  on(
    ArchiveInvoiceComplete,
    UnArchiveInvoiceComplete,
    SendInvoiceComplete,
    RefundInvoiceComplete,
    (state, { update }) => updateOne(adapter, update, { ...state, isUpdating: false })
  ),
  on(
    PayInvoiceWithSavedCard,
    SetInvoicePaymentGateway,
    EnableInvoiceOnlinePayment,
    DisableInvoiceOnlinePayment,
    UpdateInvoice,
    UpdateInvoiceStatus,
    UpdateInvoiceAddress,
    (state) => ({ ...state, isUpdating: true })
  ),
  on(ScheduleInvoice, RefundInvoice, ArchiveInvoice, UnArchiveInvoice, SendInvoice, (state) => ({
    ...state,
    isUpdating: true,
  })),
  on(DeleteInvoiceComplete, (state, { id }) => adapter.removeOne(id, state)),
  on(DeleteLocalInvoicesByIds, (state, { ids }) => adapter.removeMany(ids, state)),
  on(ApplyInvoiceTemplateComplete, (state, { invoice }) => adapter.addOne(invoice, state))
)

export function invoiceReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
